/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const address = {
  addressForm: {
    title: 'Título',
    defaultTitle: 'Título',
    titleOptional: 'Título (opcional)',
    firstName: {
      label: 'Nombre',
      placeholder: 'Nombre',
    },
    lastName: {
      label: 'Apellido',
      placeholder: 'Apellido',
    },
    address1: 'Dirección 1',
    address2: 'Dirección 2 (opcional)',
    country: 'País/Región',
    city: {
      label: 'Ciudad',
      placeholder: 'Ciudad',
    },
    state: 'Estado',
    zipCode: {
      label: 'Código postal',
      placeholder: 'Postal Code/Zip',
    },
    phoneNumber: {
      label: 'Número de teléfono (opcional)',
      placeholder: '(555) 555 - 0123',
    },
    cellphone: {
      label: 'Número de teléfono móvil (opcional)',
      placeholder: '(555) 555 - 0123',
    },
    saveAsDefault: 'Guardar como predeterminado',
    chooseAddress: 'Elegir dirección',
    streetAddress: 'Dirección de la calle',
    aptSuite: 'Apto, Suite',
    selectOne: 'Seleccione una...',
    setAsDefault: 'Establecer como dirección de entrega predeterminada',
    titleRequired: 'Se requiere título.',
    userAddressAddSuccess: 'New address was added successfully!',
    userAddressUpdateSuccess: 'Address updated successfully!',
    userAddressDeleteSuccess: 'Address deleted successfully!',
    invalidAddress: 'Dirección no válida',
  },
  addressBook: {
    addNewDeliveryAddress: 'Añadir una nueva dirección de entrega',
    editDeliveryAddress: 'Editar dirección de entrega',
    areYouSureToDeleteAddress: 'Are you sure you want to delete this address?',
    addNewAddress: 'Agregar nueva dirección',
    addAddress: 'Agregar dirección',
    updateAddress: 'Actualizar dirección',
    backToAddressList: 'Volver a la lista de direcciones',
    defaultDeliveryAddress: 'Dirección de entrega predeterminada',
    additionalDeliveryAddress: 'Dirección de entrega adicional {{number}}',
  },
  addressCard: {
    default: 'PREDETERMINADO',
    selected: 'Seleccionado',
    setAsDefault: 'Establecer como predeterminado',
    shipTo: 'Enviar a',
    billTo: 'Facturar a',
    phoneNumber: 'P',
    mobileNumber: 'M',
  },
  addressSuggestion: {
    verifyYourAddress: 'Verifica tu dirección',
    ensureAccuracySuggestChange:
      'Para garantizar la precisión de la entrega, sugerimos el cambio seleccionado a continuación.',
    chooseAddressToUse: 'Por favor, elija la dirección que desea utilizar:',
    suggestedAddress: 'Dirección sugerida',
    enteredAddress: 'Dirección introducida',
    editAddress: 'Editar dirección',
    saveAddress: 'Guardar dirección',
  },
  addressMessages: {
    setAsDefaultSuccessfully:
      'La dirección {{ streetAddress }} se estableció correctamente como predeterminada',
  },
};
